import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Grid, Image, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import LoadingCustomSVG from '../../../assets/images/icons/loading-custom.svg';

const Banner = ({ props }) => {

    /*
        - defaultData
    */
    const [balance, setBalance] = React.useState('loading');

    React.useEffect(() => {
        if (props.balance.status === 200) {
            setBalance(props.balance.data);
        }
    }, [props]);

    return (
        <Grid>
            <Grid.Wrapper>
                <Grid.Item
                    size='cl-12'>
                    <Box
                        className={`d-flex flex-wrap justify-content-between align-item-center px-xl py-lg border-solid border-success rounded-sm`}
                        ms={{
                            gap: '8px',
                            backgroundColor: 'var(--green-ultra-light)'
                        }}>
                        <Box>
                            <Typography
                                className={`d-block`}>
                                سقف اعتبار
                            </Typography>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--gray-medium)'
                                }}>
                                {balance !== 'loading' && `${(Math.floor(balance.credit.creditLimit) / 10).toLocaleString()} تومان`}
                                {balance === 'loading' &&
                                    <Image
                                        className={`d-inline`}
                                        src={LoadingCustomSVG}
                                        ms={{
                                            width: '20px',
                                            height: '20px'
                                        }} />
                                }
                            </Typography>
                        </Box>
                        <Box
                            ms={{
                                width: '1px',
                                height: '32px',
                                backgroundColor: 'var(--gray-light)',
                                '@media(max-width:576px)': {
                                    display: 'none'
                                }
                            }} />
                        <Box>
                            <Typography
                                className={`d-block`}>
                                موجودی اعتبار
                            </Typography>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--gray-medium)'
                                }}>
                                {balance !== 'loading' && `${(Math.floor(balance.credit.creditBalance) / 10).toLocaleString()} تومان`}
                                {balance === 'loading' &&
                                    <Image
                                        className={`d-inline`}
                                        src={LoadingCustomSVG}
                                        ms={{
                                            width: '20px',
                                            height: '20px'
                                        }} />
                                }
                            </Typography>
                        </Box>
                        <Box
                            ms={{
                                width: '1px',
                                height: '32px',
                                backgroundColor: 'var(--gray-light)',
                                '@media(max-width:576px)': {
                                    display: 'none'
                                }
                            }} />
                        <Box>
                            <Typography
                                className={`d-block`}>
                                بدهی قابل پرداخت
                            </Typography>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--gray-medium)'
                                }}>
                                {balance !== 'loading' && `${(Math.floor(balance.credit.creditDebt) / 10).toLocaleString()} تومان`}
                                {balance === 'loading' &&
                                    <Image
                                        className={`d-inline`}
                                        src={LoadingCustomSVG}
                                        ms={{
                                            width: '20px',
                                            height: '20px'
                                        }} />
                                }
                            </Typography>
                        </Box>
                        <Box
                            ms={{
                                width: '1px',
                                height: '32px',
                                backgroundColor: 'var(--gray-light)'
                            }} />
                        <Box>
                            <Typography
                                className={`d-block`}>
                                کیف پول
                            </Typography>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: `${props.insufficientStatus === false ? 'var(--gray-medium)' : 'var(--red-medium)'}`
                                }}>
                                {balance !== 'loading' && `${(Math.floor(balance.wallet.walletBalance) / 10).toLocaleString()} تومان`}
                                {balance === 'loading' &&
                                    <Image
                                        className={`d-inline`}
                                        src={LoadingCustomSVG}
                                        ms={{
                                            width: '20px',
                                            height: '20px'
                                        }} />
                                }
                            </Typography>
                        </Box>
                    </Box>
                </Grid.Item>
            </Grid.Wrapper>
        </Grid>
    );

}

export default Banner;